import BasePlaybookList from './BasePlaybookList';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import PlaybooksEmptyMessage from '../crm_ui/profile/sidebar/playbooks/PlaybooksEmptyMessage';
import { LoadingOverlay } from 'foundations-components/transitional/components/LoadingOverlay';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function PlaybookList({
  isLoading,
  result,
  isError,
  searchText,
  onClickPlaybook
}) {
  if (result.total === 0 || isError) {
    return isError ? /*#__PURE__*/_jsx(View, {
      as: "span",
      marginBlockStart: "100",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "cardPlaybooks.playbooksIndex.error"
      })
    }) : /*#__PURE__*/_jsx(View, {
      as: "span",
      marginBlockStart: "100",
      children: /*#__PURE__*/_jsx(PlaybooksEmptyMessage, {
        query: searchText
      })
    });
  }
  return /*#__PURE__*/_jsxs(TFlex, {
    direction: "column",
    align: "stretch",
    "data-selenium-test": "playbooks-list",
    children: [result.results.map(playbookWithRecommendation => {
      const {
        playbook,
        recommendationType
      } = playbookWithRecommendation;
      const {
        contentId,
        name
      } = playbook;
      return /*#__PURE__*/_jsx(BasePlaybookList, {
        handleOnClick: () => onClickPlaybook(playbookWithRecommendation),
        name: name,
        playbook: playbook,
        recommendationType: recommendationType
      }, `playbookButton.${contentId}`);
    }), isLoading && /*#__PURE__*/_jsx(LoadingOverlay, {
      contextual: true
    })]
  });
}